module.exports = __webpack_public_path__ + "static/media/DSC_0146-2.a5250fbb.jpg";